











































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Account } from "@/models/account";
import loader from "@/components/loader.vue";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import moment from "moment";

import { NSLog } from "@/helpers/log";
import OrderHelpers, { Order } from "../../models/order";
import { ServiceMatrix } from "@/models/serviceMatrix";
import { Warehouse } from "@/models/warehouse";
const log = NSLog("view/PlaceUserOrder");

@Component({
  components: {
    loader
  }
})
export default class ConfirmOrder extends Vue {
  valid: boolean = false;
  confirmDialog = false;

  @Getter("serviceMatrix") serviceMatrix!: ServiceMatrix[];
  get services() {
    return this.serviceMatrix.find(
      (mtix) => mtix.id === this.order!.service_matrix_id
    ) || { warehouse_id: 0 };
  }
  @Getter("warehouses") warehouses!: Warehouse[];
  get warehouse() {
    if (!this.order) return { id: 0 };
    return (
      this.warehouses.find(
        (wh) => wh.id === this.services!.warehouse_id
      ) || { id: 0 }
    );
  }
  @Getter("salesConsultants") private salesConsultants!: Account[];
  get salesAgent() {
    if (!this.order) return '';
    const o = this.order;
    return this.salesConsultants.find((acc) => o.sales_agent_id == acc.id) || ''
  }
  get customItemsNonPUR() {
    if (!this.order) return [];
    return this.order.packages.filter((p) => p.category == 'custom' && !p.shippable)
  }


  private get confirmationInfoComplete() {
    if (!this.valid) return false;
    return OrderHelpers.ConfirmationInfoComplete(this.order);
  }
  private get needsApproval() {
    return OrderHelpers.NeedsApproval(this.order);
  }

  private get requestedDueDate() {
    if (
      !this.order ||
      !this.order.requested_due_date ||
      Number(this.order.requested_due_date) < 1000
    ) {
      return "";
    }

    return moment
      .unix(Number(this.order.requested_due_date))
      .format("YYYY-MM-DD");
  }

  private get paymentDueDate() {
    if (
      !this.order ||
      !this.order.payment_due_date ||
      Number(this.order.payment_due_date) < 1000
    ) {
      return "";
    }

    return moment
      .unix(Number(this.order.payment_due_date))
      .format("YYYY-MM-DD");
  }
  @Mutation("setLastErr") public setLastErr: any;

  // order passed as prop, then emit('update',{field: value}, sync?) to update.
  @Prop({ required: true }) public order?: Order;
  private loading = false;

  private leadSources = [
    "Digital marketing | Mailer",
    "Digital marketing | Website ",
    "Digital marketing | Google Campaign",
    "Digital marketing | Facebook Campaign",
    "Digital marketing | Linked-in Campaign",
    "Marketing event",
    "Resubscription ",
    "Up-selling existing customer",
    "Project",
    "Sales Source"
  ];

  private showRequestedDueDatePicker = false;
  private showPaymentDuePicker = false;

  private async doConfirmOrApproveOrder() {
    this.loading = true;
    try {
      this.$emit("checkoutOrder");
    } catch (e) {
      log(e);
    }
    // this.loading = false;
  }

  updateCheckbox(field: string, v: any) {
    console.log({ [field]: v || false })
    this.$emit("update", { [field]: v || false }, true);
  }

  @debounce(500, { leading: false })
  private updateSalesNotes(v: any) {
    this.$emit("update", { notes: v }, true);
  }

  @debounce(500, { leading: false })
  private updateInvoiceNotes(v: any) {
    this.$emit("update", { invoice_notes: v }, true);
  }

  @debounce(500, { leading: false })
  private updateLeadSorce(v: any) {
    this.$emit("update", { lead_source: v }, true);
  }

  @debounce(500, { leading: false })
  private updateLeadNotes(v: any) {
    this.$emit("update", { lead_notes: v }, true);
  }
  private setRequestedDueDate(dt: any) {
    this.showRequestedDueDatePicker = false;
    this.$emit(
      "update",
      { requested_due_date: dt ? moment(dt).unix() : 0 },
      true
    );
  }
  private setPaymentDueDate(dt: any) {
    this.showPaymentDuePicker = false;
    this.$emit(
      "update",
      { payment_due_date: dt ? moment(dt).unix() : 0 },
      true
    );
  }

  private updatePOReference(v:string){
    this.$emit("update", { purchase_order_reference: v }, true);
  }

  private destroyed() {
    cancel(this.updateSalesNotes);
    cancel(this.updateLeadSorce);
    cancel(this.updateLeadNotes);
  }

  rules = {
    required: [(v: any) => !!v || 'Required'],
  }
}
